import * as React from 'react'
import { useState } from 'react'
import Popup from 'reactjs-popup'
import FilePreview from 'reactjs-file-preview'

interface FilePreviewPopupProps {
  file: {
    url: string
    filename: string
    download_url: string
  }
  files?: FilePreviewPopupProps['file'][]
  currentIndex?: number
}

export default function FilePreviewPopup({ file, files = [], currentIndex = 0 }: FilePreviewPopupProps) {
  const [currentFileIndex, setCurrentFileIndex] = useState(currentIndex)
  const currentFile = files.length > 0 ? files[currentFileIndex] : file
  const popupTitle = currentFile.filename

  const handlePrevious = () => {
    if (currentFileIndex > 0) {
      setCurrentFileIndex(currentFileIndex - 1)
    }
  }

  const handleNext = () => {
    if (currentFileIndex < files.length - 1) {
      setCurrentFileIndex(currentFileIndex + 1)
    }
  }
  return (
    <Popup
      trigger={
        <button type="button" className="btn btn-outline-secondary">
          <i className="fa fa-icon fa-eye" />
        </button>
      }
      position="center center"
      contentStyle={{ width: '100%', height: '100vh', maxWidth: '100vw', maxHeight: '100vh' }}
      modal
    >
      {closeModal => (
        <div className="files-button-modal modal-popup" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="files-button-modal-header popup-header">
            <a className="close" onClick={closeModal}>
              &times;
            </a>
            {popupTitle}
          </div>
          <div className="files-button-modal-content popup-content" style={{ flex: 1, overflow: 'auto' }}>
            <FilePreview preview={currentFile.url} />
          </div>
          <div
            className="files-button-modal-actions popup-actions"
            style={{
              marginTop: 'auto',
              padding: '10px',
              borderTop: '1px solid #ddd',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary mr-2"
                onClick={handlePrevious}
                disabled={files.length === 0 || currentFileIndex === 0}
              >
                <i className="fa fa-icon fa-chevron-left" /> Forrige
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary mr-2"
                onClick={handleNext}
                disabled={files.length === 0 || currentFileIndex === files.length - 1}
              >
                Næste <i className="fa fa-icon fa-chevron-right" />
              </button>
              <a
                className="btn btn-outline-secondary mr-2"
                href={currentFile.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-icon fa-external-link-alt" /> Åbn
              </a>
              <a className="btn btn-outline-secondary mr-2" href={currentFile.download_url}>
                <i className="fa fa-icon fa-download" /> Hent
              </a>
              <button type="button" className="btn btn-outline-secondary" onClick={closeModal}>
                Luk
              </button>
            </div>
          </div>
        </div>
      )}
    </Popup>
  )
}
